import { NoDataMessage } from './NoDataMessage';
import { Campaigns } from '../assets/campaigns';

type MultiMediumEmptyStateProps = {
  totalCampaigns: number;
  totalSelectedCrossMetrics: number;
  totalSelectedMediums: number;
};

export const emptyStateTitles = {
  noMediums: {
    title: 'There are no selected campaign mediums',
  },
  noSelectedMetrics: {
    title: 'There are no selected metrics',
  },
  noCampaigns: {
    title: 'There are no campaigns that match your filters',
  },
};

export const emptyStateSubtitle = 'Adjust your filters and try again.';

export const MultiMediumEmptyState = ({
  totalCampaigns,
  totalSelectedCrossMetrics = 0,
  totalSelectedMediums = 0,
}: MultiMediumEmptyStateProps) => {
  const { noMediums, noSelectedMetrics, noCampaigns } = emptyStateTitles;

  if (totalSelectedMediums === 0) {
    return <NoDataMessage Icon={Campaigns} title={noMediums.title} subtitle={emptyStateSubtitle} />;
  }
  if (totalSelectedCrossMetrics === 0) {
    return (
      <NoDataMessage
        Icon={Campaigns}
        title={noSelectedMetrics.title}
        subtitle={emptyStateSubtitle}
      />
    );
  }
  if (totalCampaigns === 0) {
    return (
      <NoDataMessage Icon={Campaigns} title={noCampaigns.title} subtitle={emptyStateSubtitle} />
    );
  }
  return <></>;
};
